<template>
<div>
   <div style="height:60px" class="hidden-md-and-up"></div>
  <h2>Control y Supervisión del Ejercicio Profesional</h2>
  <v-layout row wrap align-center>
    <v-flex x16 md7 sm12>
      <Requisito :titulo="abogado.titulo" subheader="" :requisitos="abogado.requisitos"/>
    </v-flex>
    <v-flex x16 md5 sm12>
        <v-card class="elevation-10 px-1">
          <v-card-title primary-title class="title font-weight-bold"></v-card-title>
          <v-spacer></v-spacer><v-img  src="https://apirpa2.justicia.gob.bo/pagina/varios/plataforma_sitrea_pasos_tribunal_2023.jpg" contain aspect-ratio="0.9"></v-img>
          <v-card-title primary-title class="title font-weight-bold"></v-card-title>
        </v-card>
     </v-flex>
    <v-flex sm12>
      <Requisito
        subheader="NOTAS IMPORTANTES:"
        :requisitos="abogado.notas"
      />
      </v-flex>
    <v-flex sm12>
      <v-card>
        <v-card-title primary-title class="headline font-weight-bold">
          <v-icon>account_balance</v-icon>   Centro de Conciliación
        </v-card-title>
        <v-card-text class="text-sm-left mx-2">
          El Centro de Conciliación Extrajudicial del Registro Público de la Abogacía (CC-RPA), brindará el servicio de conciliación de manera gratuita;
          en cuanto a lo referente al control de la ética profesional de la Abogacía en el marco de la Ley Nº 387 y su Decreto Supremo Reglamentario,
          como un mecanismo alternativo de solución de conflictos suscitados entre Profesionales Abogados y la Sociedad Civil en general.
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  </div>
</template>
<script>
import Requisito from "@/components/Registro/Requisito";
export default {
  components: {
    Requisito
  },
  data() {
    return {
      abogado: {
        titulo: "Sistema de los Tribunales de Ética de la Abogacía - SITREA",
        requisitos: [
          {
            title: '¿Cómo denunciar a una abogada o abogado en la plataforma "SITREA"?',
            subtitle: "La denuncia deberá ser presentada ante el Ministerio de Justicia y Transparencia Institucional a través del Sistema de los Tribunales de Ética de la Abogacía “SITREA”, por infracciones a la ética.",       
          },
          {
            icon: "fingerprint",
            iconClass: "mr-2 primary white--text",
            title: "La o el denunciante deberá contar con Ciudadanía Digital",
            subtitle:
                  "¿No tienes cuenta? Presiona aquí <a href='https://www.gob.bo/ciudadania/registrate' target='_blank' style='color:#2196f3'><i><b>www.gob.bo/ciudadania</a></b></i> para registrarte."
          },
          {
            icon: "gavel",
            //iconClass: "primary white--text",
            iconClass: "mr-1 primary white--text",
            title: "Ingrese al Sistema de Tribunales de Ética de la Abogacía - SITREA",
            subtitle:"Para realizar tu denuncia ingresa a: <a href='https://tribunaletica.justicia.gob.bo/#/' style='color:#2196f3' target='_blank'><i><b>tribunaletica.justicia.gob.bo</a></i></b>, y selecciona la opción <FONT SIZE=2 style='color:#01395b'><b>“+ NUEVA DENUNCIA”</b></font>",
          },
          {
            icon: "file_copy",
            iconClass: "primary white--text",
            title: "Llene los datos requeridos",
            subtitle: 
              "Los datos son generados automáticamente con su Ciudadanía Digital, solo registre su <u><I>correo electrónico, número de celular y dirección de domicilio</u>."
          },
          {
            icon: "group_add",
            iconClass: "primary white--text",
            title: "Identifique a la abogada o abogado (s)",
            subtitle: 
              'Agregue más de un Denunciado presionando <FONT SIZE=2 style="color:#01395b"><b>"+ AGREGAR DENUNCIADO"</b></font>.'
          },
          {
            icon: "note_alt",
            iconClass: "primary white--text",
            title: "Registre los datos de la denuncia",
            subtitle: 
            "<li>Señale la relación circunstanciada y clara del hecho;</li><li>Indique el departamento y municipio donde ocurrieron los hechos;</li><li>Seleccione las infracciones a la ética profesional.</li>"
          },
          {
            icon: "file_present",
            iconClass: "primary white--text",
            title: "Adjunte las pruebas",
            subtitle: 
              "Deberán acompañarse o señalarse las pruebas que sustenten la denuncia.",
          },
          {
            icon: "save",
            iconClass: "primary white--text",
            title: "Guarde su denuncia",
            subtitle: 
              "Y apruebe su denuncia con <b>Ciudadanía Digital.</b>"
          },
          
        ],
        notas: [

          {
            icon: "done_outline",
            title:'',
            subtitle:  "En caso de no contar con registro en ciudadanía digital, puede apersonarse a nuestras oficinas para asistirle con el respectivo registro.  (Las direcciones se encuentran en la parte inferior de esta página).",
              
          },
          {
            icon: "done_outline",
            title:'',
            subtitle:  "La <b>relación circunstanciada y clara del hecho</b> es un resumen de la denuncia;"
          },
          {
            icon: "done_outline",
            title:'',
            subtitle:  "El nombre y dirección de la abogada o el abogado, o el domicilio procesal que le sea conocido;"
          },
          {
            icon: "done_outline",
            title:'',
            subtitle:  "Todos los datos proporcionados al Ministerio de justicia y Transparencia Institucional serán mantenidos en absoluta reserva."
          }
        ]
      }
    };
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Denuncia/index.vue